import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuration } from 'src/app/app.constants';
import { FilterTypeSelectorViewModel } from '../viewModels/filters/filterTypeSelectorViewModel';

@Injectable({
  providedIn: 'root',
})
export class GenerateAccountFiltersService {

  constructor(private http: HttpClient, private configuration: Configuration) {
    
  }

  /**
   * Getter that dynamically builds the url each time.
   * This ensures the URL updates when the backend API changes (e.g., account switching).
   */
  private get url(): string {
    return this.configuration.buildEndpoint(`Filters/`);
  }

  generateFiltersForAccount(accountId: number) {
    return this.http.post<FilterTypeSelectorViewModel[]>(`${this.url}GenerateForAccount/${accountId}`, {});
  }
}
